import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Send from "@material-ui/icons/Send";

const styles = theme => ({
  sendButton: {
    borderRadius: 0,
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    color: "#00325f",
    minHeight: "56px",
    height: "100%",
    backgroundColor: "#ffcb77",
    boxShadow: "none",
    transition: "background-color 0.1s",
    "&:disabled": { backgroundColor: "blue", color: "white" },
    "&:hover": {
      backgroundColor: "#d9a757"
    }
  }
});

class SendButton extends React.PureComponent {
  render() {
    const { classes } = this.props;
    return (
      <Fab
        className={classes.sendButton}
        disabled={this.props.disabled}
        key="send_button"
        type="submit"
        size= "large"
        title="Enviar mensaje"
        aria-label="Enviar mensaje"
      >
        <Send style={{width:"27px", height:"27px"}}/>
      </Fab>
    );
  }
}

SendButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SendButton);
